var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$vuetify.breakpoint.mdAndUp)?_c('MobileNavigation',{attrs:{"pageHeader":_vm.$t('Processes.header')}}):_vm._e(),_c('ProcessAndMessageGroupTabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }